import React, { useContext, useEffect, useState, useRef } from "react";
// import { getCorporateClient } from "../../../../Services/CorporateClient.service";
import { showAlert } from "../../../../Services/Shared.service";
import { Card, CardBody, Row } from "reactstrap";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
// import PackagesTableView from "../Tables/PackagesTableView";
import { Button,IconButton, Tooltip } from '@mui/material';
import { useParams, useNavigate } from "react-router-dom";
import { getAvatarText } from "../../../../Services/Shared.service";
import { H4, H5, H6, P } from "../../../../AbstractElements";
import { getTaxGroupList } from "../../../../Services/Packages.service";
import EditNoteIcon from '@mui/icons-material/EditNote';
import SharedDataContext from "../../../../_helper/SharedData";
import PackagesBulkCreate from "../../../FormsTariff/PackagesBulkCreate";
import TariffModal from "../../../../CommonElements/TariffModal/TariffModal";
// import NoteAddIcon from '@mui/icons-material/NoteAdd';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { getExternalThirdParty } from "../../../../Services/ExternalThirdParty.service";
import ExternalThirdpartyInput from "../../../ExternalThirdParty/ExternalThirdpartyInput";
import ExtPackagesTableView from "./Tables/ExtPackagesTableView";
// import Tooltip from '@mui/material/Tooltip';

function ExterenalPartyInfo() {
  const { extId } = useParams();
  const navigate = useNavigate();

  const {cityData,taxData} = useContext(SharedDataContext)
  const [corpObj, setCorpObj] = useState({});
  const [corpPackListData, setCorpPackListData] = useState([]);
  const [profileImage, setProfileImage] = useState("");
  const [isOpen,setIsOpen] = useState(false);
  const [isCreate,setIsCreate] = useState(false);
  const closeWarningHandlerRef = useRef(null);

  const handleCloseModal = () => {
    if (closeWarningHandlerRef.current) {
      closeWarningHandlerRef.current();
    } else {
      setIsCreate(false);
    }
  };
 
  useEffect(() => {
    fetchTableData()
  }, [extId]);

const fetchTableData=()=>{

  getExternalThirdParty(extId)
  .then((resp) => {
    setCorpObj(resp.data);

  })
.catch((err) => {
    showAlert("Can't able to fetch ExternalParty");
});

}

  const handleBack = () => {
    navigate(-1);
  };

  const CityName = {
    1: "Delhi",
    8: "Amritsar",
    30: "Chennai",
    32: "Goa",
    4: "Bangalore",
  };



  return (
    <div
      style={{
        paddingTop: 40,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "left",
        }}
      >
        <Button
          startIcon={<ArrowBackIosIcon />}
          sx={{
            color: "#41CC7D",
            marginBottom: 2,
          }}
          onClick={handleBack}
        >
          Back
        </Button>
      </div>

      <Card className="driver-details">
        <CardBody
          style={{
            color: "whitesmoke",
          }}
        >
          <div className="dsp-flx">
            <h1>{corpObj.companyName}</h1>
            <div>
            <Tooltip title="Create Packages">
              <IconButton  size="large" onClick={()=>setIsCreate(true)}>
                <AddCircleIcon sx={{color:"#FFFF",width:30,height:30}} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit ThirdParty Client">
              <IconButton  size="large" onClick={()=>setIsOpen(true)}>
                <EditNoteIcon sx={{color:"#FFFF",width:30,height:30}} />
              </IconButton>
            </Tooltip>
            </div>
          </div>
          <table
            // style={{
            //   width: "70%",
            // }}
          >
            <tr>
              <td>
                <td className="td-head">Name</td>
                <td className="td-dtls">{corpObj.companyName}</td>
              </td>
              <td>
                <td className="td-head">Client Type</td>
                <td className="td-dtls">
                  {corpObj.isAirportClient ? "Airport Client" : "City Client"}
                </td>
              </td>
            </tr>
            <tr>
              <td>
                <td className="td-head">Service City  </td>
                <td className="td-dtls">{CityName[corpObj.serviceCityId]}</td>
              </td>
              <td>
                <td className="td-head">Address </td>
                <td className="td-dtls">{corpObj.addressLine}</td>
              </td>
            </tr>
            <tr>
              <td>
                <td className="td-head">Contact Person </td>
                <td className="td-dtls">{corpObj.contactPerson}</td>
              </td>
              <td>
                <td className="td-head">City </td>
                <td className="td-dtls">{corpObj.city}</td>
              </td>
            </tr>
            <tr>
              <td>
                <td className="td-head">Moile Number </td>
                <td className="td-dtls">{corpObj.mobile}</td>
              </td>

              <td>
                <td className="td-head">State </td>
                <td className="td-dtls">{corpObj.state}</td>
              </td>
            </tr>
            <tr>
              <td>
                <td className="td-head">Email </td>
                <td className="td-dtls">{corpObj.email}</td>
              </td>
            </tr>
            <tr>
              <td>
                <td className="td-head">Tax </td>
                <td className="td-dtls">
                  {`Base ${corpObj?.baseFareTaxPercentage} Service ${corpObj?.serviceFareTaxPercentage}`}
                </td>
              </td>
            </tr>
          </table>
        </CardBody>
      </Card>

      <div>
        <ExtPackagesTableView corpId={extId} />
      </div>
      <ExternalThirdpartyInput fetchTableData={fetchTableData} cityData={cityData} editId={extId} isOpen={isOpen} setIsOpen={setIsOpen}/>
      <TariffModal
        isOpen={isCreate}
        size="xl"
        centered
        toggler={handleCloseModal}
        title="Create Packages"
      >
        <PackagesBulkCreate
          handleCloseModal={() => setIsCreate(false)}
          registerCloseHandler={(handler) => {
            closeWarningHandlerRef.current = handler;
          }}
        />
      </TariffModal>
    </div>
  );
}

export default ExterenalPartyInfo;
